module.exports = __webpack_public_path__ + "static/media/Solar System Simulation.c501a071.png";